import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createUser } from '@services/users.service';
import { USERS_QUERY_KEY } from './useUsers';

export const useCreateUser = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (body) => createUser(body),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: USERS_QUERY_KEY });
        },
    });
};
